import React from 'react';
import { useParams } from 'react-router-dom';
import useWorkOrderDetails from 'screens/Applications&WorkOrders/WorkOrders/Hooks/useWorkOrderDetails';
import workOrderNotification from 'screens/Applications&WorkOrders/WorkOrders/Components/Notification';
import { OperationType } from 'components/RecordsListView/constants';
import ExportOperationPdf from 'screens/Applications&WorkOrders/Components/ExportOperationPdf';

interface RouteParams {
  workOrderId: string;
}

const ExportWorkOrderPdf: React.FC = () => {
  const { workOrderId } = useParams<RouteParams>();

  const {
    workOrderDetails,
    isLoading: isLoadingDetails,
    errors
  } = useWorkOrderDetails(workOrderId ?? '');

  return (
    <ExportOperationPdf
      operationType={OperationType.WORK_ORDER}
      operationId={workOrderId}
      operationDetails={workOrderDetails}
      isLoadingDetails={isLoadingDetails}
      errors={errors}
      notification={workOrderNotification}
    />
  );
};

export default ExportWorkOrderPdf;
